import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { Loader2 } from "lucide-react";

export default function SignoutCallbackPage() {
  const auth = useAuth();

  useEffect(() => {
    const complete = async () => {
      await auth.removeUser();

      const mainHost = window.location.hostname.replace(/-?portal\./, "");
      const port = window.location.port ? `:${window.location.port}` : "";
      window.location.href = `${window.location.protocol}//${mainHost}${port}/`;
    };
    complete();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-12 w-12 animate-spin text-primary mx-auto mb-4" />
        <p className="text-muted-foreground">Signing out...</p>
      </div>
    </div>
  );
}
